import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, Event, NavigationEnd, NavigationStart, NavigationCancel } from '@angular/router';
import { CommonService } from 'src/app/shared/service/common/common.service'
import { AppRoutes } from "../../../shared/lib/api-constant";
import { StorageService } from '../storage/storage.service';
import { FilterService } from 'primeng/api';
import { FilterServiceService } from '../FilterService/filter-service.service';


@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private currentNav: INavigationData = { route: '', routeType: '' };
  private currentNavPromise = new BehaviorSubject<INavigationData>(this.currentNav);
  public $currentNav = this.currentNavPromise.asObservable();


  private _availableRoutes: any;

  get availableRoutes() {
    if (!this._availableRoutes) {
      this._availableRoutes = {
        HOME: this.commonService.getRoute({ route: AppRoutes.User.HOME, type: 'User' }),
        LIST_VIEW: this.commonService.getRoute({ route: AppRoutes.User.LIST_VIEW, type: 'User' }),
        CONTRACT_AGREEMENT_CREATION: this.commonService.getRoute({ route: AppRoutes.User.CONTRACT_AGREEMENT_CREATION, type: 'User' }),
        CONTRACT_AGREEMENT_APPROVAL: this.commonService.getRoute({ route: AppRoutes.User.CONTRACT_AGREEMENT_APPROVAL, type: 'User' }),
        ALERT_SUBSCRIPTION: this.commonService.getRoute({ route: AppRoutes.User.ALERT_SUBSCRIPTION, type: 'User' }),
        CONTRACT_CSV_UPLOAD: this.commonService.getRoute({ route: AppRoutes.User.CONTRACT_CSV_UPLOAD, type: 'User' }),
        ROLE_MANAGEMENT: this.commonService.getRoute({ route: AppRoutes.User.ROLE_MANAGEMENT, type: 'User' }),
        COMPANY_MANAGEMENT: this.commonService.getRoute({ route: AppRoutes.User.COMPANY_MANAGEMENT, type: 'User' }),
        PORT_MASTER_DATA_MANAGEMENT: this.commonService.getRoute({ route: AppRoutes.User.PORT_MASTER_DATA_MANAGEMENT, type: 'User' }),
        CURRENCY_MANAGEMNT: this.commonService.getRoute({ route: AppRoutes.User.CURRENCY_MANAGEMNT, type: 'User' }),
        USER_MANAGEMENT: this.commonService.getRoute({ route: AppRoutes.User.USER_MANAGEMENT, type: 'User' }),
        USER_MANAGEMENT_CONFIG: this.commonService.getRoute({ route: AppRoutes.User.USER_MANAGEMENT_CONFIG, type: 'User' }),
        CONTRACT_CSV_HISTORY: this.commonService.getRoute({ route: AppRoutes.User.CONTRACT_CSV_HISTORY, type: 'User' }),
        STATUS_CONFIGURATION: this.commonService.getRoute({ route: AppRoutes.User.STATUS_CONFIGURATION, type: 'User' }),
        PORT_CONFIGURATION: this.commonService.getRoute({ route: AppRoutes.User.PORT_CONFIGURATION, type: 'User' }),
        RELEASE_NOTES: this.commonService.getRoute({ route: AppRoutes.User.RELEASE_NOTES, type: 'User' }),
        COMMON_USER_CONFIG: this.commonService.getRoute({ route: AppRoutes.UserAbstract.DYNAMIC_USER_CONFIG, type: 'User' }),
        LIST_VIEW_UNMAPPED: this.commonService.getRoute({ route: AppRoutes.User.LIST_VIEW_UNMAPPED, type: 'User' }),
        LIST_VIEW_TERMINATED: this.commonService.getRoute({ route: AppRoutes.User.LIST_VIEW_TERMINATED, type: 'User' }),
      };
    }
    return this._availableRoutes;
  }

  constructor(
    private router: Router,
    private commonService: CommonService,
    private storageService: StorageService,
    private filterService: FilterServiceService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        let url = this.router.url;
          const routerDetails = {
            filterVisibility: false,
          }
        this.filterService.changeFilterVisibility(routerDetails);
        this.setRedirectUrl(url);

        if (url) {
          const navData: INavigationData = {
            route: url,
            routeType: this.availableRoutes.HOME
          }
          switch (navData.route) {
            case this.availableRoutes.HOME: {
              navData.routeType = AppRoutes.User.HOME;
              break;
            }
            
            case this.availableRoutes.LIST_VIEW: {
              navData.routeType = AppRoutes.User.LIST_VIEW;
              break;
            }
             case this.availableRoutes.LIST_VIEW_UNMAPPED: {
              navData.routeType = AppRoutes.User.LIST_VIEW_UNMAPPED;
              break;
            }
            case this.availableRoutes.LIST_VIEW_TERMINATED: {
              navData.routeType = AppRoutes.User.LIST_VIEW_TERMINATED;
              break;
            }
            case this.availableRoutes.STATUS_CONFIGURATION: {
              navData.routeType = AppRoutes.User.STATUS_CONFIGURATION;
              break;
            }
            case this.availableRoutes.PORT_CONFIGURATION: {
              navData.routeType = AppRoutes.User.PORT_CONFIGURATION;
              break;
            }
            case this.availableRoutes.RELEASE_NOTES: {
              navData.routeType = AppRoutes.User.RELEASE_NOTES;
              break;
            }
            case this.availableRoutes.CONTRACT_AGREEMENT_CREATION: {
              navData.routeType = AppRoutes.User.CONTRACT_AGREEMENT_CREATION;
              break;
            }
            case this.availableRoutes.CONTRACT_AGREEMENT_APPROVAL: {
              navData.routeType = AppRoutes.User.CONTRACT_AGREEMENT_APPROVAL;
              break;
            }
            case this.availableRoutes.ALERT_SUBSCRIPTION: {
              navData.routeType = AppRoutes.User.ALERT_SUBSCRIPTION;
              break;
            }
            case this.availableRoutes.ROLE_MANAGEMENT: {
              navData.routeType = AppRoutes.User.ROLE_MANAGEMENT;
              break;
            }
            case this.availableRoutes.USER_MANAGEMENT: {
              navData.routeType = AppRoutes.User.USER_MANAGEMENT;
              break;
            }
            case this.availableRoutes.USER_MANAGEMENT_CONFIG: {
              navData.routeType = AppRoutes.User.USER_MANAGEMENT_CONFIG;
              break;
            }
            case this.availableRoutes.CURRENCY_MANAGEMNT: {
              navData.routeType = AppRoutes.User.CURRENCY_MANAGEMNT;
              break;
            }
            case this.availableRoutes.PORT_MASTER_DATA_MANAGEMENT: {
              navData.routeType = AppRoutes.User.PORT_MASTER_DATA_MANAGEMENT;
              break;
            }
            case this.availableRoutes.COMPANY_MANAGEMENT: {
              navData.routeType = AppRoutes.User.COMPANY_MANAGEMENT;
              break;
            }
            case this.availableRoutes.CONTRACT_CSV_UPLOAD: {
              navData.routeType = AppRoutes.User.CONTRACT_CSV_UPLOAD;
              break;
            }
            case this.availableRoutes.CONTRACT_CSV_HISTORY: {
              navData.routeType = AppRoutes.User.CONTRACT_CSV_HISTORY;
              break;
            }
            case this.availableRoutes.COMMON_USER_CONFIG: {
              navData.routeType = AppRoutes.UserAbstract.DYNAMIC_USER_CONFIG;
          }
        } 
        this.currentNav = navData;
        this.currentNavPromise.next(navData);
      }
    }
    });

  }

  private setRedirectUrl(url?: any) {

    // Sets redirect to Home page
    this.storageService.setItem('redirectUrl', `/#${this.availableRoutes.HOME}`);
  }
}

export interface INavigationData {
  route: string;
  routeType: string;
}
